import { render, staticRenderFns } from "./InclusionView.vue?vue&type=template&id=6769d41a&"
import script from "./InclusionView.vue?vue&type=script&lang=js&"
export * from "./InclusionView.vue?vue&type=script&lang=js&"
import style0 from "./InclusionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports